/** What each Event Suite plan costs and includes. Prices are billed monthly. */
export type SuitePlan = "standard" | "premium";
export const TRIAL_DAYS = 7;

export interface PlanCard { name: string; monthlyUsd: string; features: string[] }

export const PLAN_CARDS: Record<SuitePlan, PlanCard> = {
  standard: {
    name: "Event Suite",
    monthlyUsd: "29.99",
    features: [
      "All thirteen event products for any kind of event",
      "Starter plans: checklist, budget and running order",
      "One shared project across every product",
      "1 GB of account storage: save and reopen your projects from any device",
    ],
  },
  premium: {
    name: "Event Suite Premium",
    monthlyUsd: "49.99",
    features: [
      "Everything in Event Suite, plus:",
      "The Guest, Door Check and Booth Leads event apps, with live event data",
      "Email invitations sent in your name, with RSVP links and scheduled reminders",
      "Text-message reminders to guests who choose them, sent from your own Twilio number",
    ],
  },
};

export const planPriceLine = (plan: SuitePlan) => `Billed monthly, cancel any time`;
